import { useTranslation } from 'react-i18next'

export function CTA() {
  const { t } = useTranslation()

  return (
    <section className="cta">
      <div className="container">
        <h2>{t('landing.cta.title')}</h2>
        <h3>{t('landing.cta.subtitle')}</h3>
        <a href="#" className="btn-secondary">
          <i className="fas fa-play"></i> {t('landing.cta.button')}
        </a>
      </div>
    </section>
  )
}
